(function () {
    'use strict';

    angular.module("imApp").factory("orderHeadCalcsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 885,
                    parameters: parms || {}
                });
            },
            listCalculations: function (parms) {
                return $ihttp.post({
                    method: 887,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
